import { createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  productionNumberActiveKey: 1,
  refashionActiveKey: 1,
  specialInterestActiveKey: 1,
  finalRoundActiveKey: 1,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
